<template>
  <div
    class="yesno"
    :class="{
      yesno_clearable: clearable,
      yesno_vertical: vertical,
      'yesno_fit-content': fitContent
    }"
  >
    <span
      v-for="option of finalOptions"
      :key="option.value"
      class="yesno__option"
      :class="{ yesno__option_active: value == option.value }"
      @click="onClick(option.value)"
    >
      {{ option.label }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    options: {
      type: [Object, Array],
    },
    clearable: {
      type: Boolean,
    },
    vertical: {
      type: Boolean,
    },
    clearValue: {
      default: null,
    },
    fitContent: {
      type: Boolean,
    },
  },
  computed: {
    finalOptions() {
      if (this.options) {
        return this.parseOptions(this.options);
      }

      return this.defaultOptions;
    },
    defaultOptions() {
      return [
        {
          value: 'yes',
          label: this.$t('YES'),
        },
        {
          value: 'no',
          label: this.$t('NO'),
        },
      ];
    },
  },
  methods: {
    parseOptions(options) {
      if (Array.isArray(options)) {
        return options;
      }

      return Object.entries(options).map(([value, label]) => ({ value, label }));
    },
    onClick(key) {
      if (this.clearable && this.value === key) {
        this.$emit('input', this.clearValue);
        return;
      }

      this.$emit('input', key);
    },
  },
};
</script>

<style lang="scss" scoped>
.yesno {
  display: flex;

  &_vertical {
    flex-direction: column;

    .yesno__option:not(:first-child) {
      margin-left: 0;
      margin-top: -1px;
    }
  }

  &_clearable {
    .yesno__option_active {
      cursor: pointer;
    }
  }

  &_fit-content {
    width: fit-content;
  }

  &__option {
    text-transform: capitalize;
    padding: 6px 10px;
    flex-grow: 1;
    border: 1px solid #e5e5e5;
    position: relative;
    cursor: pointer;

    &_active {
      background-color: var(--lighter-primary);
      border-color: lighten($primary, 25);
      z-index: 1;
      cursor: default;
    }

    &:first-child {
      border-radius: 2px 0 0 2px;
    }

    &:not(:first-child) {
      margin-left: -1px;
    }

    &:last-child {
      border-radius: 0 2px 2px 0;
    }
  }
}
</style>
